import Utils from '../utils';

function currentRegion(state = '', action){
	switch(action.type){
		case 'SELECT_REGION':

		let selectedRegion = action.selectedRegion;
		if(selectedRegion === 'Yorkshire and the Humber'){
			selectedRegion = 'Yorkshire';
		}

		return  Utils.cleanString(selectedRegion)
		
		case 'CLOSE_REGION':
		return  ''
		
		default : 
		return state;

	}
}

export default currentRegion;


// WEBPACK FOOTER //
// ./src/js/reducers/currentRegion.js